import React from 'react';
import { toast } from 'react-toastify';

const StepSelfPayFee = ({ data, onChange, onNext, onBack, loading = false, error, success }) => {

    const handleNext = (e) => {
        e.preventDefault();
        if (!data.fees) {
            toast.error('Please enter your session fee.');
            return;
        }
        onNext();
    };

    return (
        <form onSubmit={handleNext} style={{ display: 'flex', flexDirection: 'column', gap: 24, padding: '20px 0' }}>
            <div style={{ display: 'flex', justifyContent: 'left' }}>
                <svg xmlns="http://www.w3.org/2000/svg" width="30" height="54" viewBox="0 0 30 54" fill="none">
                    <path d="M8.15233 18.2069C8.15233 15.3684 12.1591 14.8838 15.6347 14.8838C18.9104 14.8838 23.3865 16.4744 27.1291 18.4848L27.8625 10.6615C25.9908 9.55279 21.6488 8.23709 17.2384 7.96213L18.3072 0H11.1575L12.2278 7.96213C3.00753 8.86084 0 14.3988 0 19.0376C0 30.7369 21.0456 28.2473 21.0456 35.4441C21.0456 38.1464 18.5755 39.1133 14.2311 39.1133C8.35238 39.1133 3.94075 36.9695 1.67067 34.7524L0.533608 43.5453C2.67373 44.861 7.01433 46.0376 12.2278 46.3155L11.1575 54H18.3072L17.2384 46.2449C28.0625 45.275 30 39.3206 30 35.3762C30.0002 21.462 8.15233 24.9215 8.15233 18.2069Z" fill="#27B99A" />
                </svg>
            </div>

            <h2 style={{ margin: 0 }}>Self-Pay Fee</h2>

            <p style={{
                margin: 0,
                fontFamily: "'Poppins', sans-serif",
                fontSize: 14,
                color: '#333',
                lineHeight: '1.4',
                textAlign: 'left',
                maxWidth: '90%'
            }}>
                Enter your session fee for clients who are paying out-of-pocket. This amount will be shown before booking to ensure full transparency.
            </p>

            <div style={{ position: 'relative', marginTop: 10 }}>
                <span style={{
                    position: 'absolute',
                    left: 45,
                    top: '50%',
                    transform: 'translateY(-50%)',
                    fontSize: 18,
                    color: '#828282',
                    fontFamily: "'Poppins', sans-serif"
                }}>$</span>
                <input
                    type="number"
                    placeholder=""
                    value={data.fees}
                    onChange={e => {
                        const value = e.target.value;
                        const intValue = value.replace(/[^0-9]/g, '');
                        onChange('fees', intValue);
                    }}
                    style={{
                        width: '100%',
                        height: 80,
                        padding: '12px 15px 12px 65px',
                        borderRadius: 12,
                        border: 'none',
                        background: '#F2F2F7',
                        fontSize: 20,
                        fontFamily: "'Poppins', sans-serif",
                        outline: 'none',
                        color: '#000'
                    }}
                    min="0"
                    step="1"
                />
            </div>

            <div style={{ display: 'flex', gap: 12, marginTop: 16 }}>
                <button
                    type="submit"
                    disabled={loading || success}
                    style={{
                        padding: 0,
                        background: 'none',
                        border: 'none',
                        cursor: loading || success ? 'not-allowed' : 'pointer',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'flex-start',
                        opacity: loading || success ? 0.6 : 1,
                    }}
                >
                    <div style={{
                        display: 'flex',
                        alignItems: 'center',
                        background: loading ? '#5a8c9e' : '#07405A',
                        borderRadius: 8,
                        boxShadow: '0px 4px 12px 0px rgba(7, 64, 90, 0.10)',
                        padding: '0 24px 0 24px',
                        height: 48,
                        minWidth: 160,
                        transition: 'background-color 0.2s ease',
                        position: 'relative',
                        gap: 10,
                    }}>
                        <span style={{
                            color: '#fff',
                            fontWeight: 700,
                            fontSize: 16,
                            fontFamily: 'inherit',
                            marginRight: 24,
                        }}>
                            {loading ? 'Saving...' : success ? 'Submitted' : 'Submit'}
                        </span>
                        <span style={{ position: 'absolute', right: 10 }}>
                            <svg width="37" height="37" viewBox="0 0 37 37" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <circle cx="18.3673" cy="18.3673" r="17.8673" fill="white" fillOpacity="0.1" stroke="white" />
                                <path d="M17.993 11.995L24.7402 18.7421L17.993 24.7396" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                <path opacity="0.5" d="M13 13.7257L18.2478 18.8853L13 23.4716" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                            </svg>
                        </span>
                    </div>
                </button>
            </div>
        </form>
    );
};

export default StepSelfPayFee;
